module onvio.common {
    'use strict';
    export class OnvioPrivacyFooterController {
        public isVisible: boolean;
        public privacyEffectiveDate: Date;
        public preference: onvio.clientDashboard.IPreferences = {
            id: null,
            application: 'Platform',
            category: 'privacy-statement',
            value: null
        };

        static $inject = [
            'bmPrivacyPolicyService',
            'onvio.clientDashboard.PreferenceService',
            '$scope'
        ];
        constructor(
            privacyPolicyService: any,
            private preferenceService: onvio.clientDashboard.PreferenceService,
            private $scope: ng.IScope,
        ) {
            this.isVisible = false;
            //Effective date 25-May-2018, note that in javascript month is from 0-11
            this.privacyEffectiveDate = new Date(2018, 4, 25);
            preferenceService.loadPreferences(this.preference.application, this.preference.category).then((result: onvio.clientDashboard.IPreferences) => {
                if (result) {
                    this.preference = result;
                    if (this.privacyEffectiveDate > new Date(this.preference.value)) {
                        this.isVisible = true;
                    } else {
                        this.isVisible = false;
                    }
                } else {
                    this.isVisible = true;
                }
            }).catch(() => {
                angular.noop();
            });
            $scope.$on('close', () => {
                this.Close();
            });
        }

        public Close() {
            this.preference.value = (new Date()).toDateString();
            this.preferenceService.storePreference(this.preference).then(() => {
                this.isVisible = false;
            }).catch(() => {
                angular.noop();
            });
        }

    }

    export class OnvioPrivacyFooterComponent implements ng.IComponentOptions {
        controller = OnvioPrivacyFooterController;
        templateUrl = 'common/privacy-footer/privacy-footer.html';
    }

    angular.module('onvio.common.privacyFooter', [])
        .component('privacyFooter', new OnvioPrivacyFooterComponent());
}
